import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { CREATE_CONTACT } from '../../../apollo';

interface ContactInput {
  name: string;
  email: string;
  practice: string;
}

type CreateContactEffectReturn = {
  createContact: (contact: ContactInput) => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

export const useCreateContactEffect = (
  callback?: (data?: any) => void
): CreateContactEffectReturn => {
  const [success, setSuccess] = useState(false);

  const [doCreateContact, { loading, error }] = useMutation(CREATE_CONTACT, {
    onCompleted: (data) => {
      setSuccess(true);
      if (callback) {
        callback(data.createContact);
      }
    },
  });

  const createContact = (data: ContactInput): void => {
    const variables = { data };

    doCreateContact({ variables }).then();
  };

  return {
    createContact,
    loading,
    success,
    error: error?.message,
  };
};
